<a class="footer-menu-item" [routerLink]="item.url | localize">{{ item.name | translate }}</a>
